import React from 'react';
import { View, Text, TouchableWithoutFeedback } from 'react-native';
import PropTypes from 'prop-types';

import './GlyphIcon.module.scss';

export const BLOCKED = '\u00AC';
export const CHEVRON_UP = '5';
export const CHEVRON_DOWN = '6';
export const CHEVRON_LEFT = '<';
export const INFO = 'j';
export const INFO_UNFILLED = 'i';
export const GINKGO = 's';
export const HAMBURGER = 'J';
export const BOOKMARK = '\xe5';
export const PHONE = 'T';
export const SMS = 'o';
export const SMALL_X = 'w';
export const LARGE_X = 'x';
export const CHECK = '/';
export const FILLED_PLUS = '\xFF';
export const ARROW_CURVED = '\u02DC';
export const PENCIL = '\u03C0';
export const TRASH_CAN = '\u00B5';
export const CAMERA = 'P';
export const CAMERA_PLUS = '\u00c7';
export const RELOAD = 'r';
export const CLOCK = 'l';
export const CHECK_CIRCLE = 'Y';
export const X_CIRCLE = 'Z';
export const LEFT_ARROW = '0';
export const STAR_SOLID = 'R';
export const TWITTER = '|';
export const FACEBOOK = '{';
export const INSTAGRAM = '\u00f1';
export const ENVELOPE = 'b';
export const SMS_SOLID = '\u00f2';

interface IGlyphIconProps {
  content: string;
  className?: string;
  antialiased?: boolean;
  style?: any;
  styleName?: string;
  onPress?: () => void;
}

const AnyView = View as any;
const AnyText = Text as any;

/**
 * Renders a font icon from the `sbp-glyphs` font family, wrapped in a `TouchableWithoutFeedback`
 * component. Use one of the constants exported by this module to specify a particular icon.
 */
const GlyphIcon: React.FC<IGlyphIconProps> = ({
  content,
  className,
  antialiased,
  style,
  ...restProps
}) => (
  <TouchableWithoutFeedback {...restProps}>
    <AnyView styleName="glyph-icon-component">
      <AnyText styleName={`glyphIcon ${antialiased ? 'antialiased' : ''}`} className={className} style={style}>{content}</AnyText>
    </AnyView>
  </TouchableWithoutFeedback>
);

export const IconPropType = PropTypes.oneOf([
  BLOCKED,
  CHEVRON_UP,
  CHEVRON_DOWN,
  CHEVRON_LEFT,
  INFO,
  INFO_UNFILLED,
  GINKGO,
  HAMBURGER,
  BOOKMARK,
  PHONE,
  SMS,
  LARGE_X,
  SMALL_X,
  CHECK,
  FILLED_PLUS,
  ARROW_CURVED,
  PENCIL,
  TRASH_CAN,
  CAMERA,
  CAMERA_PLUS,
  RELOAD,
  CLOCK,
  CHECK_CIRCLE,
  X_CIRCLE,
  LEFT_ARROW,
  STAR_SOLID,
  TWITTER,
  FACEBOOK,
  INSTAGRAM,
  ENVELOPE,
  SMS_SOLID,
]);

GlyphIcon.propTypes = {
  /** The icon to display */
  content: IconPropType.isRequired,
  /** A class name, which can be used to supply color, font size, etc */
  className: PropTypes.string,
  style: PropTypes.any,

  /**
   * if true then use the browser's built-in antialiasing to smooth
   * the font display. This may be necessary for some icons to display
   * correctly
   */
  antialiased: PropTypes.bool,
};

GlyphIcon.defaultProps = {
  className: null,
  style: null,
};

export default GlyphIcon;
